import React from "react";
import { useSelector } from "react-redux";

// Scss
import "./ProjectKPIsDashboard.scss";

// Icons & Packages
import DropdownAngle from "assets/icons/dropdown-angle.svg";
import DropdownAngleLight from "assets/icons/dropdown-angle-light.svg";
import ClusterSPIIcon from "assets/icons/cluster-spi-icon.svg";
import SiteHandoverKPIIcon from "assets/icons/site-handover-kpi.svg";
import SiteHandoverKPIIconLight from "assets/icons/handover-kpi-light.svg";
import ScheduleUpdateKPIIcon from "assets/icons/schedule-update-kpi.svg";
import ScheduleUpdateKPIIconLight from "assets/icons/schedule-update-light.svg";
import ScheduleApprovalKPIIcon from "assets/icons/schedule-approval-kpi.svg";
import ScheduleApprovalKPIIconLight from "assets/icons/schedule-approval-light.svg";
import UnderHandoverKPIIcon from "assets/icons/under-handover-kpi.svg";
import UnderHandoverKPIIconLight from "assets/icons/under-handover-light.svg";
import NRCIcon from "assets/icons/nrc.svg";
import NRCIconLight from "assets/icons/nrc-light.svg";
import PaymentApplicationIcon from "assets/icons/payment-application.svg";
import PaymentApplicationIconLight from "assets/icons/payment-application-light.svg";
import VariationOrderIcon from "assets/icons/variation-order.svg";
import VariationOrderIconLight from "assets/icons/variation-order-light.svg";
import InitialAcceptanceIcon from "assets/icons/initial-acceptance.svg";
import InitialAcceptanceIconLight from "assets/icons/initial-acceptance-light.svg";
import StartIcon from "assets/icons/star.svg";
import NearToDelayedIcon from "assets/icons/near-to-delayed.svg";
import NearToTroubledIcon from "assets/icons/near-to-troubled.svg";
import CalendarSmallIcon from "assets/icons/calendar-small.svg";
import NoteWhiteIcon from "assets/icons/note-white.svg";
import NoteWhiteIconLight from "assets/icons/notesmall-white-light.svg";

// Importing Components

import StackedChart from "components/charts/StackedCharts";
import GuageChart from "components/charts/GuageChart";
import HorColumnChart from "components/charts/HorColumnChart";

function ProjectKPIsDashboard() {
  const selectedTheme = useSelector((state) => state.globalConfig.theme);
  return (
    <>
      {/* Dropdowns Wrapper */}
      <section className="dropdowns-wrapper">
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Central</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Eastern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>North Western</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Northern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>S. Project</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Southern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
      </section>

      {/* Cluster SPI Pane */}
      <section className="clusterspi-wrapper">
        <div className="clusterspi-container">
          <div className="cp-title">
            <img src={ClusterSPIIcon} alt="#" />
            <span>Cluster SPIs</span>
          </div>
          <div className="cp-list">
            <ul>
              <li>
                <span>Western </span>
                <span>29%</span>
              </li>
              <li>
                <span>Northern East </span>
                <span>17.5%</span>
              </li>
              <li>
                <span>South West </span>
                <span>44.33%</span>
              </li>
              <li>
                <span>Western </span>
                <span>26.09%</span>
              </li>
              <li>
                <span>Northen East </span>
                <span>17.39%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Metered Tile Single Row Wrapper */}
      <section className="metered-tile-wrapper">
        <div className="metered-tile-container">
          {/* Site Handover KPI Tile */}
          <div className="tile-container">
            <div className="top">
              <span>
                {selectedTheme === "dark" ? (
                  <img src={SiteHandoverKPIIcon} alt="#" />
                ) : (
                  <img src={SiteHandoverKPIIconLight} alt="#" />
                )}
                Site Handover KPI
              </span>
            </div>
            <div className="middle">
              <div className="row-flex">
                <div className="left-info">
                  <span className="blank">(Blank)</span>
                  <span className="title">Projects Delayed</span>
                  <span className="green">Site Handover &gt; 60 Days</span>
                  <span className="amount">0.00</span>
                  <span className="currency">SAR</span>
                </div>
                <div className="chart-container">
                  <div className="info-number">2.3k</div>
                  <div className="needle-background">
                    <div className="circle"></div>
                  </div>
                  {selectedTheme === "dark" ? (
                    <GuageChart colorset={"#272C2F"} />
                  ) : (
                    <GuageChart colorset={"#F1F2F3"} />
                  )}
                </div>
                <div className="right-info">
                  <span className="iconblue">
                    <img src={StartIcon} alt="#" />
                    23
                  </span>
                  <span className="green">
                    Recently
                    <br />
                    Awarded
                    <br />
                    Projects
                  </span>
                </div>
              </div>
              <div className="row-flex">
                <div className="statistics-container">
                  <div
                    className="statistics-loader green"
                    style={{ width: "56%" }}
                  >
                    <div className="circle-thumb green">12</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bottom">
              <span>{`Site Hand < 60 Days`}</span>
              <span>{`Site Hand > 60 Days, < 75 Days`}</span>
              <span>{`Site Hand > 75 Days`}</span>
            </div>
          </div>
          {/* Schedule Update KPI Tile */}
          <div className="tile-container">
            <div className="top">
              <span>
                {selectedTheme === "dark" ? (
                  <img src={ScheduleUpdateKPIIcon} alt="#" />
                ) : (
                  <img src={ScheduleUpdateKPIIconLight} alt="#" />
                )}
                Schedule Update KPI
              </span>
            </div>
            <div className="middle">
              <div className="row-flex">
                <div className="left-info">
                  <span className="blank">(Blank)</span>
                  <span></span>
                  <span className="green">
                    Projects
                    <br />
                    Not Updated
                    <br />
                    &gt; 37 Days
                  </span>
                </div>
                <div className="chart-container">
                  <div className="info-number blank">Blank</div>
                  <div className="needle-background">
                    <div className="circle"></div>
                  </div>
                  {selectedTheme === "dark" ? (
                    <GuageChart colorset={"#272C2F"} />
                  ) : (
                    <GuageChart colorset={"#F1F2F3"} />
                  )}
                </div>
                <div className="right-info">
                  <span className="blank">(Blank)</span>
                  <span></span>
                  <span className="amount">0.00</span>
                  <span className="currency">SAR</span>
                </div>
              </div>
              <div className="row-flex">
                <div className="statistics-container">
                  <div
                    className="statistics-loader red"
                    style={{ width: "68%" }}
                  >
                    <div className="circle-thumb red">28.3</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bottom">
              <span>{`Delayed`}</span>
              <span>{``}</span>
              <span>{`Regular`}</span>
            </div>
          </div>
          {/* Schedule Approval KPI Tile */}
          <div className="tile-container">
            <div className="top">
              <span>
                {selectedTheme === "dark" ? (
                  <img src={ScheduleApprovalKPIIcon} alt="#" />
                ) : (
                  <img src={ScheduleApprovalKPIIconLight} alt="#" />
                )}
                Schedule Approval KPI
              </span>
            </div>
            <div className="middle">
              <div className="row-flex">
                <div className="left-info">
                  <span className="blank">(Blank)</span>
                  <span></span>
                  <span className="green">
                    Site With No
                    <br /> Scheduled
                  </span>
                  <span className="amount">0.00</span>
                  <span className="currency">SAR</span>
                </div>
                <div className="chart-container">
                  <div className="info-number">0.00</div>
                  <div className="needle-background">
                    <div className="circle"></div>
                  </div>
                  {selectedTheme === "dark" ? (
                    <GuageChart colorset={"#272C2F"} />
                  ) : (
                    <GuageChart colorset={"#F1F2F3"} />
                  )}
                </div>
                <div className="right-info">
                  <span className="iconblue">
                    <img src={StartIcon} alt="#" />
                    23
                  </span>
                  <span className="green">
                    Started <br />
                    Projects
                  </span>
                  <span className="date">Since Jan 2022</span>
                </div>
              </div>
              <div className="row-flex statistics-wrapper"></div>
            </div>
            <div className="bottom">
              <span>{`Site Hand < 60 Days`}</span>
              <span>{`Site Hand > 60 Days, < 75 Days`}</span>
              <span>{`Site Hand > 75 Days`}</span>
            </div>
          </div>
        </div>
      </section>

      {/* Metered Tile Single Row Wrapper */}
      <section className="metered-tile-wrapper">
        <div className="metered-tile-container">
          {/* Under Handover KPI Tile */}
          <div className="tile-container">
            <div className="top">
              <span>
                {selectedTheme === "dark" ? (
                  <img src={UnderHandoverKPIIcon} alt="#" />
                ) : (
                  <img src={UnderHandoverKPIIconLight} alt="#" />
                )}
                Under Handover KPI
              </span>
            </div>
            <div className="middle">
              <div className="row-flex">
                <div className="left-info">
                  <span className="blank">(Blank)</span>
                  <span></span>
                  <span className="green">
                    Projects Under Handover &gt; 60 Days
                  </span>
                </div>
                <div className="chart-container">
                  <div className="info-number">2.73k</div>
                  <div className="needle-background">
                    <div className="circle"></div>
                  </div>
                  {selectedTheme === "dark" ? (
                    <GuageChart colorset={"#272C2F"} />
                  ) : (
                    <GuageChart colorset={"#F1F2F3"} />
                  )}
                </div>
                <div className="right-info">
                  <span className="amount   amount-light">15.44bn</span>
                  <span className="currency currency-light">SAR</span>
                </div>
              </div>
              <div className="row-flex">
                <div className="statistics-container">
                  <div
                    className="statistics-loader green"
                    style={{ width: "56%" }}
                  >
                    <div className="circle-thumb green">12</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bottom">
              <span>{`Handover (<60 Days)`}</span>
              <span>{`Handover (>60 <75 Days)`}</span>
              <span>{`Handover > 75 Days`}</span>
            </div>
          </div>

          {/* NRC Tile */}
          <div className="tile-container">
            <div className="top">
              <span>
                {selectedTheme === "dark" ? (
                  <img src={NRCIcon} alt="#" />
                ) : (
                  <img src={NRCIconLight} alt="#" />
                )}
                NRC
              </span>
            </div>
            <div className="middle">
              <div className="row-flex">
                <div className="left-info">
                  <span className="blank">(Blank)</span>
                  <span></span>
                  <span className="green">
                    Projects Not Updated &gt; 37 Days
                  </span>
                </div>
                <div className="chart-container">
                  <div className="info-number">2.73k</div>
                  <div className="needle-background">
                    <div className="circle"></div>
                  </div>
                  {selectedTheme === "dark" ? (
                    <GuageChart colorset={"#272C2F"} />
                  ) : (
                    <GuageChart colorset={"#F1F2F3"} />
                  )}
                </div>
                <div className="right-info">
                  <span className="iconblue">
                    <img src={StartIcon} alt="#" />
                    23
                  </span>
                  <span className="green">
                    Pending NCR <br /> &lt; 5 Days
                  </span>
                </div>
              </div>
              <div className="row-flex">
                <div className="statistics-container">
                  <div
                    className="statistics-loader green"
                    style={{ width: "65%" }}
                  >
                    <div className="circle-thumb center green">3</div>
                  </div>
                  <div
                    className="statistics-loader red"
                    style={{ width: "35%" }}
                  >
                    <div className="circle-thumb center red">2</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bottom">
              <span>Regular</span>
              <span></span>
              <span>Delayed</span>
            </div>
          </div>

          {/* Payment Application Tile */}
          <div className="tile-container">
            <div className="top">
              <span>
                {selectedTheme === "dark" ? (
                  <img src={PaymentApplicationIcon} alt="#" />
                ) : (
                  <img src={PaymentApplicationIconLight} alt="#" />
                )}
                Payment Application
              </span>
            </div>
            <div className="middle">
              <div className="row-flex">
                <div className="left-info">
                  <span className="blank">(Blank)</span>
                  <span></span>
                  <span className="green">
                    Site With No
                    <br /> Scheduled
                  </span>
                  <span className="amount">0.00</span>
                  <span className="currency">SAR</span>
                </div>
                <div className="chart-container">
                  <div className="info-number">3.00</div>
                  <div className="needle-background">
                    <div className="circle"></div>
                  </div>
                  {selectedTheme === "dark" ? (
                    <GuageChart colorset={"#272C2F"} />
                  ) : (
                    <GuageChart colorset={"#F1F2F3"} />
                  )}
                </div>
                <div className="right-info">
                  <span className="iconblue">
                    <img src={StartIcon} alt="#" />
                    23
                  </span>
                  <span className="green">
                    Started <br />
                    Projects
                  </span>
                  <span className="date">Since Jan 2022</span>
                </div>
              </div>
              <div className="statistics-container">
                <div className="statistics-loader red" style={{ width: "88%" }}>
                  <div className="circle-thumb red">28.3</div>
                </div>
              </div>
            </div>
            <div className="bottom">
              <span>{`Site Hand < 60 Days`}</span>
              <span>{`Site Hand > 60 Days, < 75 Days`}</span>
              <span>{`Site Hand > 75 Days`}</span>
            </div>
          </div>
        </div>
      </section>

      {/* Metered Tile Single Row Wrapper */}
      <section className="metered-tile-wrapper">
        <div className="metered-tile-container">
          {/* Variation Order Tile */}
          <div className="tile-container">
            <div className="top">
              <span>
                {selectedTheme === "dark" ? (
                  <img src={VariationOrderIcon} alt="#" />
                ) : (
                  <img src={VariationOrderIconLight} alt="#" />
                )}
                Variation Order
              </span>
            </div>
            <div className="middle">
              <div className="row-flex">
                <div className="left-info">
                  <span className="blank">(Blank)</span>
                  <span></span>
                  <span className="green">
                    Projects Under Handover &gt; 60 Days
                  </span>
                </div>
                <div className="chart-container">
                  <div className="info-number">0.00</div>
                  <div className="needle-background">
                    <div className="circle"></div>
                  </div>
                  {selectedTheme === "dark" ? (
                    <GuageChart colorset={"#272C2F"} />
                  ) : (
                    <GuageChart colorset={"#F1F2F3"} />
                  )}
                </div>
                <div className="right-info">
                  <span className="amount amount-light">15.44bn</span>
                  <span className="currency currency-light">SAR</span>
                </div>
              </div>
              <div className="row-flex">
                <div className="statistics-container">
                  <div
                    className="statistics-loader green"
                    style={{ width: "56%" }}
                  >
                    <div className="circle-thumb green">12</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bottom">
              <span>{`Handover (<60 Days)`}</span>
              <span>{`Handover (>60 <75 Days)`}</span>
              <span>{`Handover > 75 Days`}</span>
            </div>
          </div>

          {/* Initial Acceptance  Tile */}
          <div className="tile-container">
            <div className="top">
              <span>
                {selectedTheme === "dark" ? (
                  <img src={InitialAcceptanceIcon} alt="#" />
                ) : (
                  <img src={InitialAcceptanceIconLight} alt="#" />
                )}
                Initial Acceptance
              </span>
            </div>
            <div className="middle">
              <div className="row-flex">
                <div className="left-info">
                  <span className="blank">(Blank)</span>
                  <span></span>
                  <span className="green">
                    Projects Not Updated &gt; 37 Days
                  </span>
                </div>
                <div className="chart-container">
                  <div className="info-number">2.73k</div>
                  <div className="needle-background">
                    <div className="circle"></div>
                  </div>
                  {selectedTheme === "dark" ? (
                    <GuageChart colorset={"#272C2F"} />
                  ) : (
                    <GuageChart colorset={"#F1F2F3"} />
                  )}
                </div>
                <div className="right-info">
                  <span className="iconblue">
                    <img src={StartIcon} alt="#" />
                    23
                  </span>
                  <span className="green">
                    Pending NCR <br /> &lt; 5 Days
                  </span>
                </div>
              </div>
              <div className="row-flex">
                <div className="statistics-container">
                  <div
                    className="statistics-loader green"
                    style={{ width: "55%" }}
                  >
                    <div className="circle-thumb center green">3</div>
                  </div>
                  <div
                    className="statistics-loader orange"
                    style={{ width: "25%" }}
                  >
                    <div className="circle-thumb center orange">1</div>
                  </div>
                  <div
                    className="statistics-loader red"
                    style={{ width: "20%" }}
                  >
                    <div className="circle-thumb center red ">2</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bottom">
              <span>Regular</span>
              <span></span>
              <span>Delayed</span>
            </div>
          </div>

          {/* Delayed Troubled Application Tile */}
          <div className="tile-container fade">
            <div className="nor-delayed">
              <div className="left">
                <img src={NearToDelayedIcon} alt="#" />
              </div>
              <div className="center">
                <span>
                  Near <br /> To <br /> Delayed
                </span>
              </div>
              <div className="right">
                <span>Blank</span>
                <span>SAR</span>
              </div>
            </div>
            <div className="nor-troubled">
              <div className="left">
                <img src={NearToTroubledIcon} alt="#" />
              </div>
              <div className="center">
                <span>
                  Near <br /> To <br /> Troubled
                </span>
              </div>
              <div className="right">
                <span>Blank</span>
                <span>SAR</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Info Section */}
      <section className="projects-info-wrapper">
        <div className="projects-info-container">
          <div className="left">
            <div className="head">
              <span>
                {selectedTheme === "dark" ? (
                  <img src={NoteWhiteIcon} alt="#" />
                ) : (
                  <img src={NoteWhiteIconLight} alt="#" />
                )}
                Annual Projects Completion Plan Vs Actual
              </span>
            </div>
            <div className="body">
              <div className="chart-container">
                <div className="chart">
                  {selectedTheme === 'dark'?
                   <StackedChart
                   data={{
                     categories: [
                       "JAN 2022",
                       "FEB 2022",
                       "MAR 2022",
                       "APR 2022",
                       "MAY 2022",
                       "JUN 2022",
                       "JUL 2022",
                       "AUG 2022",
                       "SEP 2022",
                       "OCT 2022",
                       "NOV 2022",
                       "DEC 2022",
                     ],
                     data: [
                       [
                         37.8, 20.3, 40.8, 36.8, 40.5, 35.3, 34.9, 43.6, 45.7,
                         35.9, 42.7,
                       ],
                       [
                         37.8, 20.3, 40.8, 36.8, 40.5, 35.3, 34.9, 43.6, 45.7,
                         35.9, 42.7,
                       ],
                     ],
                   }}
                   colorset={{
                     firstSet: [
                       "rgba(233, 99, 28, 0.5)",
                       "rgba(39, 44, 47, 1)",
                     ],
                     secondSet: [
                       "rgba(35, 157, 156, 0.5)",
                       "rgba(39, 44, 47, 1)",
                     ],
                   }}

                   label={"#272C2F"}
                   linecolor={"#272C2F"}
                 />:
                 <StackedChart
                 data={{
                   categories: [
                     "JAN 2022",
                     "FEB 2022",
                     "MAR 2022",
                     "APR 2022",
                     "MAY 2022",
                     "JUN 2022",
                     "JUL 2022",
                     "AUG 2022",
                     "SEP 2022",
                     "OCT 2022",
                     "NOV 2022",
                     "DEC 2022",
                   ],
                   data: [
                     [
                       37.8, 20.3, 40.8, 36.8, 40.5, 35.3, 34.9, 43.6, 45.7,
                       35.9, 42.7,
                     ],
                     [
                       37.8, 20.3, 40.8, 36.8, 40.5, 35.3, 34.9, 43.6, 45.7,
                       35.9, 42.7,
                     ],
                   ],
                 }}
                 colorset={{
                   firstSet: [
                     "rgba(233, 99, 28, 0.5)",
                     "rgba(39, 44, 47, 1)",
                   ],
                   secondSet: [
                     "rgba(35, 157, 156, 0.5)",
                     "rgba(39, 44, 47, 1)",
                   ],
                 }}

                 label={"#424B51"}
                 linecolor={"#f1f2f3"}
               />
                }
                 
                </div>
                <div className="chart-info">
                  <div className="tile">
                    <img src={CalendarSmallIcon} alt="#" />
                    <span>Start Date</span>
                    <span>16-Jan-2022</span>
                  </div>
                  <div className="tile">
                    <img src={CalendarSmallIcon} alt="#" />
                    <span>Finish Date</span>
                    <span>16-Jan-2022</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="right">
            <div className="head">
              <span>
                {selectedTheme === "dark" ? (
                  <img src={NoteWhiteIcon} alt="#" />
                ) : (
                  <img src={NoteWhiteIconLight} alt="#" />
                )}
                Projects Progress
              </span>
            </div>
            <div className="body">
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Year</th>
                      <th># Of Projects</th>
                      <th>Budget (SAR)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>2019</td>
                      <td>5</td>
                      <td>123,345</td>
                    </tr>
                    <tr>
                      <td>2020</td>
                      <td>3</td>
                      <td>123,345</td>
                    </tr>
                    <tr>
                      <td>2021</td>
                      <td>8</td>
                      <td>123,345</td>
                    </tr>
                    <tr>
                      <td>2022</td>
                      <td>10</td>
                      <td>123,345</td>
                    </tr>
                    <tr>
                      <td>2023</td>
                      <td>4</td>
                      <td>123,345</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Info Section */}
      <section className="projects-infotable-wrapper">
        <div className="projects-infotable-container">
          <div className="left">
            <div className="body">
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Projects</th>
                      <th>Cluster</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Project Status</th>
                      <th>Budget (SAR)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ</td>
                      <td>Northern East</td>
                      <td>25-Jun-06</td>
                      <td>25-Jun-06</td>
                      <td>Regular</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ</td>
                      <td>Northern East</td>
                      <td>25-Jun-06</td>
                      <td>25-Jun-06</td>
                      <td>Regular</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ</td>
                      <td>Northern East</td>
                      <td>25-Jun-06</td>
                      <td>25-Jun-06</td>
                      <td>Regular</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ</td>
                      <td>Northern East</td>
                      <td>25-Jun-06</td>
                      <td>25-Jun-06</td>
                      <td>Regular</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ</td>
                      <td>Northern East</td>
                      <td>25-Jun-06</td>
                      <td>25-Jun-06</td>
                      <td>Regular</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ</td>
                      <td>Northern East</td>
                      <td>25-Jun-06</td>
                      <td>25-Jun-06</td>
                      <td>Regular</td>
                      <td>123,342,344</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="right">
            <div className="head">
              <span>
                {selectedTheme === "dark" ? (
                  <img src={NoteWhiteIcon} alt="#" />
                ) : (
                  <img src={NoteWhiteIconLight} alt="#" />
                )}
                Projects Time Overrun / Years
              </span>
            </div>
            <div className="body">
              <div className="top-info">
                <div className="info">Time Overrun</div>
                <div className="left">10</div>
                <div className="right">
                  <span>406.34 M</span>
                  <span>SAR</span>
                </div>
              </div>
              <div className="chart-horizontal-container">
                {selectedTheme === "dark" ? (
                  <HorColumnChart colorset={"#31383D"} backcolor={"#272C2F"}  label={"#F1F2F3"}/>
                ) : (
                  <HorColumnChart colorset={"#D6D6D6"} backcolor={"#f1f2f3"} label={"#6E7D87"}/>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProjectKPIsDashboard;
